<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
        <g clip-path="url(#clip0_1_1)">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.666992 10C0.666992 4.84536 4.84567 0.666687 10.0003 0.666687C15.155 0.666687 19.3337 4.84535 19.3337 10C19.3337 15.1547 15.155 19.3334 10.0003 19.3334C4.84566 19.3334 0.666992 15.1547 0.666992 10ZM10.0003 2.66669C5.95024 2.66669 2.66699 5.94993 2.66699 10C2.66699 14.0501 5.95025 17.3334 10.0003 17.3334C14.0504 17.3334 17.3337 14.0501 17.3337 10C17.3337 5.94994 14.0504 2.66669 10.0003 2.66669Z" fill="#EBF0FC"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M10 9C10.5523 9 11 9.44772 11 10V13.3333C11 13.8856 10.5523 14.3333 10 14.3333C9.44772 14.3333 9 13.8856 9 13.3333V10C9 9.44772 9.44772 9 10 9Z" fill="#EBF0FC"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M9 6.66669C9 6.1144 9.44772 5.66669 10 5.66669H10.0083C10.5606 5.66669 11.0083 6.1144 11.0083 6.66669C11.0083 7.21897 10.5606 7.66669 10.0083 7.66669H10C9.44772 7.66669 9 7.21897 9 6.66669Z" fill="#EBF0FC"/>
        </g>
        <defs>
            <clipPath id="clip0_1_1">
                <rect width="20" height="20" fill="white"/>
            </clipPath>
        </defs>
    </svg>

</template>

<script>
export default {
    name: 'IconAlertOutlineWhite',

    props: ['className']
};
</script>

<style lang="scss">
@import "Icons";
</style>
